<template>
    <div id="notfound">
         <h1 class="my-5 display-1">404</h1>
         <h4>Oops! we couldn't find the page. Try going<br/><br/> </h4>
         <p>
             <router-link :to="{name: 'Home'}" class="home router-link-exact-active router-link-active btn btn-pink">
                 <i aria-hidden="true" class="fa fa-chevron-left"></i> Home</router-link>
         </p>
       
    </div>
</template>
<script>
export default {
    name:'NotFound',
    data(){
        return{

        }
    }
}
</script>

<style scoped>
#notfound{
    min-height:612px;
    overflow:hidden;
}
 a.home.router-link-exact-active{
  color:#fff;
}

.btn-pink {
    color: #fff;
    background-color: #f42f2c;
    border-color: #f42f2c;
    width:150px;
    opacity:.9
}
.btn-pink:hover{
    opacity:.8;
}
.fa-chevron-left[data-v-27e953af] {
    color: #ffffff !important;
}
</style>


// WEBPACK FOOTER //
// src/views/NotFound.vue